var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsAddSeries = function SvgIconsAddSeries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C31.822 0 41 9.178 41 20.5S31.822 41 20.5 41 0 31.822 0 20.5 9.178 0 20.5 0zm0 1C9.73 1 1 9.73 1 20.5S9.73 40 20.5 40 40 31.27 40 20.5 31.27 1 20.5 1z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12.5a1 1 0 0 1 .993.883l.007.117v6h6a1 1 0 0 1 .117 1.993l-.117.007h-6v6a1 1 0 0 1-1.993.117L19.5 27.5v-6h-6a1 1 0 0 1-.117-1.993l.117-.007h6v-6a1 1 0 0 1 1-1z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
export default SvgIconsAddSeries;